import { togglePropertyStripMode } from '../../canvas/commands/ManipulationCommands';
import { LockablePropertyStripLayout } from '../../canvas/properties/LockablePropertyStripLayout';
import { lockAndMoreLayout } from '../../canvas/properties/TextPropertyStripParts';
import { commentsOpen } from '../annotations/CommentCommands';
import { tagsAddNew } from '../annotations/TaggingCommands';
import { connectorCreateFromSelection } from '../connector/ConnectorCommands';
import { RoadmapCard } from './RoadmapCard';
import { UrlWidget } from './UrlWidget';

export const roadmapCardPropertyLayout = LockablePropertyStripLayout<RoadmapCard>((d, s, o, w, a) => [
    //
    // Edit Text
    w.createButton({
        name: 'editText',
        image: 'deqo://icons/i8/text',
        text: 'Edit Text',
        onAction() {
            d(togglePropertyStripMode);
        },
    }),
    w.createDivide(),
    //
    // Background
    w.createColorSelector({
        text: 'Background Color',
        autoSelect: true,
        groups: true,
        value: a.get('background'),
        onSelect() {
            o.update(u => {
                u.rolling(a.keyFor('background'));
                a.set('background', this.value!);
            });
        }
    }),
    w.createButton({
        image: 'deqo://icons/d2/connector',
        text: 'Connect To...',
        onAction() {
            d(connectorCreateFromSelection);
        }
    }),
    // External Link
    w.createPopout({
        value: a.get('externalLink'),
        text: 'External Link',
        image: 'deqo://icons/hero/link',
        ui: UrlWidget,
        onSelect() {
            o.update(() => a.set('externalLink', this.value!));
        }
    }),
    ...(a.count === 1 ? [
        w.createButton({
            image: 'deqo://icons/d2/comment-small',
            text: 'Add Comment',
            onAction() {
                d(commentsOpen, [a.get('id'), true]);
            }
        }),
        w.createButton({
            image: 'deqo://icons/hero/tag',
            text: 'Add Tag',
            onAction() {
                d(tagsAddNew, [a.get('id')]);
            }
        }),
    ] : []),
    w.createDivide(),
    ...lockAndMoreLayout(d, s, o, w, a),
]);
